import React from 'react';
import { useAgreementTemplateQuery, useProviderLicensesStatusQuery, useStateQuery } from '@uplift/queries';
import { StateExhibitExpired } from '@uplift/api';
import { ErrorOutline } from '@mui/icons-material';
import { CalendarDateService } from '@uplift/services';
import { DateFormats } from '@uplift/constants';
import { useCurrentuser } from '@uplift/contexts';
import { DocumentListItemRow } from './DocumentListItemRow';


export const StateExhibitExpiredListItem: React.VFC<{
  document: StateExhibitExpired;
  onClick: () => void;
  selected: boolean;
}> = ({
  document,
  onClick,
  selected,
}) => {
  const me = useCurrentuser();
  const { data: template } = useAgreementTemplateQuery(document.agreementTemplateId);
  const { data: licenses } = useProviderLicensesStatusQuery(me.id, { suspense: true });
  const license = licenses?.find(l => l.id === document.licenseId);
  const { data: state } = useStateQuery(license?.stateId, { suspense: true });
  const expiredAt = CalendarDateService.date(document.expiredAt, DateFormats.ISO_DATE).format(DateFormats['MMM D, YYYY']);

  return (
    <DocumentListItemRow
      name={template.name}
      status={`Expired ${expiredAt} — renew to continue seeing patients in ${state?.fullName ?? 'this state'}.`}
      statusColor="error"
      icon={<ErrorOutline />}
      onClick={onClick}
      selected={selected}
    />
  );
};
